import axios from 'axios';
import { vm } from '@/main.js'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})


api.interceptors.request.use(
    async config => {
        const token = localStorage.getItem("token")
        config.headers = {
            'Authorization': `Bearer ${token}`,
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded'
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });


api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            console.log("Unauthorized")
            console.log(JSON.stringify(error))
            vm.$store.dispatch("logout")
            vm.$router.push({ name: 'login' });
        } else if (error.response.status === 422) {
            if (error.response.data.errors) {
                console.alert(error)
                console.log(JSON.stringify(error))
                    // for (let key in error.response.data.errors) {
                    // vm.$validator.errors.add({ field: key, msg: error.response.data.errors[key] })
                    // }
            }
            // } else if (error.response.status === 403) {
            //     console.log("Unauthorized")
            //     console.log(JSON.stringify(error))
            //     vm.$store.dispatch("logout")
            //     vm.$router.push({ name: 'login' });
            // } else if (error.response.status === 500) {
            //     console.log(JSON.stringify(error))
            //     vm.$store.dispatch("logout")
            //     vm.$router.push({ name: 'login' });
        } else {
            console.error(JSON.stringify(error))
        }
        return Promise.reject(error);
    })

export default api